import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Context } from '../models/context.model';

@Injectable({
	providedIn: 'root'
})
export class ContextService {
	private _context: Context;
	private _contextSubject = new BehaviorSubject<Context | null>(null);

	get context(): Context {
		return this._context;
	}

	set context(value: Context) {
		this._context = value;
	}

	constructor() {
		this._context = new Context();
	}

	public setObservableContext(data: Context) {
		this._contextSubject.next(data);
	}

	public getObservableContext(): BehaviorSubject<Context | null> {
		return this._contextSubject;
	}
}
